import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useStyles } from './styles';
import useIsMobile from 'hooks/useIsMobile';
import CustomButton from 'components/CustomButton';

export default function Header() {
  const classes = useStyles();
  const isMobile = useIsMobile();

  return (
    <div className={classes.root}>
      <Container>
        <div className={classes.content}>
          <div>
            <Box mt={isMobile ? 2 : 0}>
              <Typography className={classes.titleB2B} variant="h1">
                <b>
                  Easy to use Pharma <br /> Designs for Medical <br /> Communications
                </b>
              </Typography>
            </Box>

            <Box my={4}>
              <Typography component="p" variant="h6" className={classes.descriptionHeader}>
                <b>
                  Save time with your pharmaceutical communication. <br /> Teams & Labs plan is
                  perfectly suitable for pharmaceutical <br /> companies that need a professional
                  tool to upgrade their <br /> designs with scientifically accurate illustrations.
                </b>
              </Typography>

              <Box mt={4}>
                <CustomButton
                  href="https://content.mindthegraph.com/leaders-custom-service-qualification"
                  target="_blank"
                >
                  Request a Quote
                </CustomButton>
              </Box>
            </Box>
          </div>

          <Box sx={{ width: '40%' }}>
            {!isMobile && (
              <img
                src="/images/teams-and-labs/image-header-lp-b2b.webp"
                loading="eager"
                alt="image header teams and labs"
                width="493"
                height="365"
              />
            )}
          </Box>
        </div>
      </Container>
    </div>
  );
}
